import React from "react";
import { withRouter } from "react-router-dom";
import PageComponent from "../PageComponent";
import TopBar from "./TopBar";
import { withKeycloak } from "@react-keycloak/web";
import { getUser } from "../../../../keycloak/keycloakFunctions";

class TopBarContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.state = {
      party: null
    };
  }

  getComponentTitle = () => {
    return undefined;
  };

  componentDidMount() {
    super.componentDidMount();
    this.refreshPartyData();
  }

  refreshPartyData = () => {
    getUser(this.keycloak, party => this.setState({ party: party }));
  };

  logout = () => {
    this.keycloak.logout();
  };

  render() {
    return (
      <TopBar
        {...this.handlerProps()}
        party={this.state.party}
        onLogout={this.logout}
        refresh={this.refreshPartyData}
        breadcrumbsRef={this.props.breadcrumbsRef}
        onBreadcrumbClick={this.props.onBreadcrumbClick}
        onHomeMenuClick={this.props.onHomeMenuClick}
        notificationBadgeRefreshPropagator={
          this.props.notificationBadgeRefreshPropagator
        }
      />
    );
  }
}

export default withKeycloak(withRouter(TopBarContainer));
